// 依存するヘルパー関数をインポート
import {
  transformSkillsAttributes,
  transformRolesAttributes,
  transformOperationsAttributes,
} from "./transformHelpers";

/**
 * エンティティ名ごとの属性prefix
 */
const ATTR_PREFIX_MAP = {
  project: "project",
  job: "job",
};

/**
 * プロジェクト送信用のリクエストボディを生成する関数
 *
 * @param {Object} formState - フォームの入力値（state管理されている値）
 * @param {Object} existing  - 編集時に既存のプロジェクトデータを渡す（新規作成時は空オブジェクトでOK）
 * @param {("project"|"job")} entityKey - ルートキー名（デフォルト: "project"）
 * @returns {Object}         - サーバー送信用のリクエストボディ（project: { ... } 形式）
 */
export function buildRequestBody(
  formState,
  existing = {},
  entityKey = "project"
) {
  const prefix = ATTR_PREFIX_MAP[entityKey] || "project";
  return {
    [entityKey]: {
      // 不要なフィールドを除外し、フォームの入力値を展開
      ...Object.fromEntries(
        Object.entries(formState).filter(
          ([key]) =>
            ![
              "prefecture_ids", // 都道府県ID（後で個別セット）
              "skills", // スキル配列（API送信用に変換）
              "operations", // 工程配列（API送信用に変換）
              "roles", // ロール配列（API送信用に変換）
              "id", // DBのID（APIには不要）
              "updated_at", // 更新日時（APIには不要）
              "prefecture_names", // 都道府県名（APIには不要）
            ].includes(key)
        )
      ),
      // 都道府県IDをセット
      prefecture_ids: formState.prefecture_ids,
      // スキル配列をAPI用に変換してセット
      [`${prefix}_skills_attributes`]: transformSkillsAttributes(
        formState.skills,
        existing.skills || [],
        !!formState.id // isEditフラグ（編集時はtrue）
      ),
      // 工程配列をAPI用に変換してセット
      [`${prefix}_operations_attributes`]: transformOperationsAttributes(
        formState.operations,
        existing.operations || [],
        !!formState.id
      ),
      // ロール配列をAPI用に変換してセット
      [`${prefix}_roles_attributes`]: transformRolesAttributes(
        formState.roles,
        existing.roles || [],
        !!formState.id
      ),
    },
  };
}
